import axios from 'axios';
import { API_URL } from './adapters';

// Thin client over /api/app-data, which stores the user-authored configuration
// documents (dashboards, chart configs, query templates, saved query results
// and data screens) that previously lived in Firestore.

export const listDocs = async (kind, params = {}) => {
  const { data } = await axios.get(`${API_URL}/app-data/${kind}`, { params });
  return data;
};

export const getDoc = async (kind, id) => {
  try {
    const { data } = await axios.get(`${API_URL}/app-data/${kind}/${id}`);
    return data;
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
};

export const createDoc = async (kind, payload) => {
  const { data } = await axios.post(`${API_URL}/app-data/${kind}`, payload);
  return data;
};

export const updateDoc = async (kind, id, payload) => {
  const { data } = await axios.put(`${API_URL}/app-data/${kind}/${id}`, payload);
  return data;
};

export const deleteDoc = async (kind, id) => {
  await axios.delete(`${API_URL}/app-data/${kind}/${id}`);
  return true;
};

// Runs a stored query template against a whitelisted collection.
export const runQuery = async ({ collection, conditions, orderBy, limit }) => {
  const { data } = await axios.post(`${API_URL}/app-data/query`, {
    collection,
    conditions,
    orderBy,
    limit
  });
  return data;
};
